import initialSyncfoniaState from "../syncfonia.initialState";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";
import { reduxActions as SYNCFONIA } from '../../syncfonia.constants';

const updateGtinProvider = {
  [SYNCFONIA.UPDATE_GTIN_PROVIDER_STARTED]: (state) => ({
    ...state,
    updateGtinProvider: {
      ...state.updateGtinProvider,
      status: LOADING
    }
  }),
    
  [SYNCFONIA.UPDATE_GTIN_PROVIDER_FAIL]: (state, { payload }) => ({
    ...state,
    updateGtinProvider: {
      ...state.updateGtinProvider,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),
    
  [SYNCFONIA.UPDATE_GTIN_PROVIDER_SUCCESS]: (state, { payload }) => ({
    ...state,
    updateGtinProvider: {
      ...state.updateGtinProvider,
      data: payload?.data ?? null,
      status: SUCCESS
    }
  }),
  
  [SYNCFONIA.UPDATE_GTIN_PROVIDER_RESET]: (state) => ({
    ...state,
    updateGtinProvider: initialSyncfoniaState.updateGtinProvider
  })
};

export default updateGtinProvider;
